import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { FlowBackFingerprintingDTO } from 'types/graph.dto';

export type GraphsState = Readonly<{
  flowBack: Record<string, FlowBackFingerprintingDTO>;
  pumpOffSelection: Record<string, boolean>;
}>;

export const initialState: GraphsState = {
  flowBack: {},
  pumpOffSelection: {},
};

const graphsSlice = createSlice({
  name: 'Graphs',
  initialState,
  reducers: {
    updateFlowBack: (
      state,
      action: PayloadAction<{ wellboreId: string; flowBack: FlowBackFingerprintingDTO }>,
    ) => {
      state.flowBack[action.payload.wellboreId] = action.payload.flowBack;
    },
    updatePumpOffSelection: (
      state,
      action: PayloadAction<{ wellboreId: string; pumpOffselection: boolean }>,
    ) => {
      state.pumpOffSelection[action.payload.wellboreId] = action.payload.pumpOffselection;
    },
  },
});

export const { updateFlowBack, updatePumpOffSelection } = graphsSlice.actions;
export default graphsSlice.reducer;
